import { render, staticRenderFns } from "./DealBookingDocumentCapture.vue?vue&type=template&id=65f26612&scoped=true"
import script from "./DealBookingDocumentCapture.vue?vue&type=script&lang=js"
export * from "./DealBookingDocumentCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f26612",
  null
  
)

export default component.exports